import React, { useCallback } from "react";
import {
  Button,
  Icon,
  Modal,
  ModalBody
} from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react/macro";
import { useAuth } from "./AuthProvider";
import { useIsTabletOrDesktop } from "@silversea-ssc/system-components-react/utils";
import * as styles from "./AuthErrorModal.module.scss";

type Props = {
  onClose?: () => void;
  fycUrl: string;
};

const AuthErrorModal: React.FC<Props> = ({ onClose, fycUrl }) => {
  const { login, clearError } = useAuth();
  const closeModal = () => {
    clearError();
    onClose?.();
  };
  const isTabletOrDesktop = useIsTabletOrDesktop();
  const gotoFYC = useCallback(() => {
    window.location.href = fycUrl;
  }, [fycUrl]);

  return (
    <Modal
      modal={{
        isOpen: true,
        onRequestClose: isTabletOrDesktop ? closeModal : undefined
      }}
      size="small"
      dataContentName="error_modal"
    >
      <ModalBody
        variant="full"
        className={styles.modalBodyWrapper}
        paddingTop={false}
        paddingBottom={false}
      >
        <div className={styles.errorIconContainer}>
          <React.Fragment>
            <Icon name="alert" size="2x" padding="inline" />{" "}
            <Trans id="login-error">Login error</Trans>
          </React.Fragment>
        </div>

        <div className={styles.modalContent}>
          <div className={styles.title}>
            <Trans id="login-error-title">An error occurred during login</Trans>
          </div>
          <div className={styles.body}>
            <Trans id="login-error-backend-message">
              We could not log you in in this session.
            </Trans>
            <br />
            <Trans id="login-error-backend-action">
              You can continue with your navigation or try logging in again.
            </Trans>
          </div>

          <div className={styles.buttonsContainer}>
            <Button
              key="retry-login"
              size="regular"
              variant="text"
              onClick={() => login()}
              dataContentPiece="error_button_retry_login"
            >
              <Trans>Retry login</Trans>
            </Button>
            <Button
              key="keep-exploring"
              size="regular"
              variant="primary"
              onClick={gotoFYC}
              dataContentPiece="error_button_keep_exploring"
            >
              <Trans>Keep exploring</Trans>
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AuthErrorModal;
